<!--
  Copyright 2020 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<h2 mat-dialog-title>
  <span> Default color </span>
</h2>
<mat-dialog-content>
  <color-circle (onChange)="handleColorChange($event)"> </color-circle>
</mat-dialog-content>
<mat-dialog-actions class="action-dialog">
  <div>
    <button type="button" mat-raised-button (click)="close()">Cancel</button>
    <button color="primary" mat-raised-button type="submit" (click)="onSave()">
      Apply
    </button>
  </div>
</mat-dialog-actions>
